import { proxy } from "valtio";

type storeType = {
  active: boolean;
  activateKozijnColor: boolean;
  layoutChanged: boolean;
};

export const store = proxy<storeType>({
  active: true,
  activateKozijnColor: false,
  layoutChanged: false,
});
